import { t } from '@/i18n';
import { passwordType } from '@/utils';
import { z } from 'zod';

export const UpdatePasswordSchema = z
  .object({
    currentPassword: z.string().min(8),
    newPassword: passwordType,
    confirmPassword: passwordType,
  })
  .refine(
    (data) =>
      !data.confirmPassword || data.newPassword === data.confirmPassword,
    {
      path: ['confirmPassword'],
      message: t('validation.password-must-match'),
    },
  );
